import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/ca", null, {}, {
    "Accept": ["application/json"]
  });
}
export function createCA(request) {
  return __request__("POST", "/ca/create", request, {}, {
    "Accept": ["application/json"]
  });
}
export function uploadCA(password, files) {
  const formData = new FormData();
  formData.append("password", password);
  files.forEach((f) => formData.append("files", f));
  return __request__("POST", "/ca/upload", formData, {}, {
    "Accept": ["application/json"]
  });
}
